import ReactGA from 'react-ga';

import { defaultAppData } from '../Shared/constants';

const { googleAnalyticsId, localizationInfo, user } = {
  ...defaultAppData,
  ...window.App,
};

ReactGA.initialize(googleAnalyticsId);

const GoogleAnalytics = ({ location }) => {
  const page = location.pathname + location.search;

  ReactGA.set({
    page,
    userId: user.id.toString(),
    dimension1: user.rootBusinessUnit.id.toString(),
    dimension2: user.currentBusinessUnit.id.toString(),
    dimension3: localizationInfo.Locale,
  });
  ReactGA.pageview(page);
  return null;
};

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./src/Root/GoogleAnalytics.js